import styled from 'styled-components';
import { FACILITY_PATHS } from '@pass-frontend/common/constants/paths';
import { env } from '@pass-frontend/features/configuration/util';
import { RdsButton } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';

const WidthConstrainer = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  display: flex;
  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const SignInButton = styled(RdsButton)`
  width: 160px;
  margin-top: 10px;
`;

const PortalContainer = styled.div`
  width: 90%;
`;

export interface FacilityHeaderProps {
  shouldHideSignInButton?: boolean;
}

const { ENABLE_LOGIN_WITH_MSID, ENABLE_LOGIN_WITH_HEALTH_SAFE_ID } = env();

export const FacilityHeader = (props: FacilityHeaderProps) => {
  const handleSignInClick = () => {
    window.open(FACILITY_PATHS.SIGN_IN, '_blank');
  };

  return (
    <div className="has-rds-mv-40">
      <WidthConstrainer>
        <PortalContainer>
          <h1 className="is-rds-h1 has-rds-font-weight-semibold">
            Partner Portal
          </h1>
          <p className="is-rds-body-1 has-rds-font-weight-medium">
            for Renew Active®, One Pass™, and Aaptiv
          </p>
        </PortalContainer>

        {(ENABLE_LOGIN_WITH_HEALTH_SAFE_ID || ENABLE_LOGIN_WITH_MSID) &&
          !props.shouldHideSignInButton && (
            <SignInButton
              type="button"
              onClick={handleSignInClick}
              variant="secondary"
            >
              Sign in
            </SignInButton>
          )}
      </WidthConstrainer>
    </div>
  );
};

export default FacilityHeader;
